import { CommonUtils, type DictType, StringUtils } from '@hglobal/utility-kit';

import { TrendDynamic } from '../../components/trend';

import {
  DisplayedFinancialMetricAmount,
  PerformanceFinancialMetricInput,
} from './financial-metric.abstraction';
import { FINANCIAL_METRIC_NAME_TO_TRANSLATION_KEY } from './financial-metric.constant';

export class FinancialMetricUtils {
  static mapDisplayedComputedAmounts(
    metrics: Readonly<Partial<Record<string, PerformanceFinancialMetricInput>>>,
    displayedMetricNames: readonly string[],
    emptyValue: string,
  ): DisplayedFinancialMetricAmount[] {
    return displayedMetricNames.map((metricName) => {
      const metric = metrics[metricName];

      if (!metric) {
        return {
          title: FinancialMetricUtils.resolveTitleTranslationKey(metricName),
          value: emptyValue,
        };
      }

      const displayedMetric: DisplayedFinancialMetricAmount = {
        title: FinancialMetricUtils.resolveTitleTranslationKey(metricName),
        value: CommonUtils.isNotNil(metric.value) ? String(metric.value) : emptyValue,
      };
      const change = FinancialMetricUtils.formatDiffPercentageChange(metric.diffPercentage);

      if (!change) {
        return displayedMetric;
      }

      return {
        ...displayedMetric,
        change,
        dynamic: metric.trendDynamic as DictType<typeof TrendDynamic>,
      };
    });
  }

  static resolveTitleTranslationKey(metricName: string): string {
    const normalizedMetricName = StringUtils.toLowerSnakeCase(metricName);
    const translationKey = FINANCIAL_METRIC_NAME_TO_TRANSLATION_KEY.get(normalizedMetricName);

    return translationKey ?? metricName;
  }

  private static formatDiffPercentageChange(diffPercentage: number | null): string | null {
    if (!CommonUtils.isNotNil(diffPercentage)) {
      return null;
    }

    return `${Number(diffPercentage.toFixed(1))}%`;
  }
}
